import { ArrowUpRight } from '@phosphor-icons/react';
import { usePublicProfileData } from '@/context/PublicProfileContext';
import type { ApiEvent } from '@/types/dashboard';

function formatEventStub(iso: string | null): { mon: string; day: string } | null {
  if (!iso) return null;
  const d = new Date(iso);
  return {
    mon: d.toLocaleDateString('en-US', { month: 'short' }),
    day: d.toLocaleDateString('en-US', { day: 'numeric' }),
  };
}

function TicketContent({ ev }: { ev: ApiEvent }) {
  const stub = formatEventStub(ev.startsAt);

  return (
    <>
      <span className="ap-ticket__stub">
        {stub ? (
          <>
            <span className="ap-ticket__mon">{stub.mon}</span>
            <span className="ap-ticket__day">{stub.day}</span>
          </>
        ) : (
          <span className="ap-ticket__tba">TBA</span>
        )}
      </span>
      <span className="ap-ticket__body">
        <span className="ap-ticket__name">{ev.name}</span>
        <span className="ap-ticket__venue">{ev.venue}</span>
        <span className="ap-ticket__city">
          {ev.isOnline ? 'Online' : ev.city}
        </span>
      </span>
      {ev.ticketUrl && (
        <a
          href={ev.ticketUrl}
          className="ap-ticket__cta"
          target="_blank"
          rel="noreferrer"
        >
          {ev.isOnline ? 'Watch' : 'Tickets'}
          <ArrowUpRight size={13} weight="bold" />
        </a>
      )}
    </>
  );
}

export function Events() {
  const { events } = usePublicProfileData();
  if (events.length === 0) return null;

  const sorted = [...events].sort((a, b) => {
    const ta = a.startsAt ? new Date(a.startsAt).getTime() : Infinity;
    const tb = b.startsAt ? new Date(b.startsAt).getTime() : Infinity;
    return ta - tb;
  });

  return (
    <>
      <div className="ap-divider" />
      <section id="events">
        <h2 className="ap-section__title">Events</h2>
        <div className="ap-events">
          {sorted.map((ev) => (
            <div key={ev.id} className="ap-ticket">
              <TicketContent ev={ev} />
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
